// import '@/mocks/look-code'
import fly from './fly'

export const fetchLookCode = (params: Object) =>
  fly.get('/mall/cs/order/getcode.json', params)
